/* eslint-disable no-new */

import { Controller } from '@hotwired/stimulus';
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

export default class extends Controller {
  connect() {
    const swiperOptions = {
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerGroup: 2,
      loop: false,
      loopFillGroupWithBlank: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 3,
          slidesPerGroupSkip: 3,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    new Swiper(this.element, swiperOptions);
  }
}
